var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloUpArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180, 11.5, 11.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 4.5,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9014 18.9955C11.1997 19.3966 11.8003 19.3966 12.0986 18.9955L18.8513 9.91391C19.2172 9.42175 18.866 8.72282 18.2527 8.72282H4.74732C4.13403 8.72282 3.78275 9.42175 4.1487 9.91391L10.9014 18.9955Z",
    fill: "#18D56F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00293 6.89517C4.00293 7.30716 4.33692 7.64115 4.74891 7.64115H18.2511C18.6631 7.64115 18.9971 7.30716 18.9971 6.89517V6.74598C18.9971 6.33399 18.6631 6 18.2511 6H11.5H4.74891C4.33692 6 4.00293 6.33399 4.00293 6.74598V6.89517Z",
    fill: "#18D56F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloUpArrow);
export default __webpack_public_path__ + "static/media/hilo-up-arrow.cf8c8abba2602d5142a85c04ce5701f2.svg";
export { ForwardRef as ReactComponent };